// import Link from "next/link";
import styles from "./Button.module.scss";
import React from "react";

interface IProps {
  children: React.ReactNode;
  href?: string;
  newTab?: boolean;
  external?: boolean;
  noStyles?: boolean;
  addStyles?: string[];
  onClick?: () => void;
}

const Button: React.FC<IProps> = ({
  children,
  href,
  newTab,
  external,
  noStyles,
  addStyles,
  onClick,
}: IProps) => {
  const defaultStyles = noStyles
    ? styles.button + " " + styles.bare
    : styles.button;
  const addClasses = addStyles?.length
    ? defaultStyles +
      " " +
      addStyles
        .map((style: string) => (styles[style] ? styles[style] : style))
        .join(" ")
    : defaultStyles;

  if (href && !onClick) {
    // if (external) {
    if (newTab) {
      return (
        <a
          className={addClasses}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {children}
        </a>
      );
    } else {
      return (
        <a className={addClasses} href={href}>
          {children}
        </a>
      );
    }
    // } else {
    //   return (
    //     <Link className={addClasses} href={href}>
    //       {children}
    //     </Link>
    //   );
    // }
  }

  if (onClick && !href) {
    return (
      <button className={addClasses} onClick={onClick}>
        {children}
      </button>
    );
  }

  if (onClick && href) {
    console.error(
      "Cannot use href and onClick at the same time in <Button /> component."
    );
  } else {
    console.error("Invalid value or missing attribute (href or onClick).");
  }

  return <>Error</>;
};

export default Button;
